// ArchiveItemsList.jsx
import React from "react";
import ArchiveElement from "../objects/ArchiveElement";
import type { VideoEntity, DocumentEntity } from "../../types/strapi";

interface ArchiveItemsListProps {
  videoItems: VideoEntity[];
  documentItems: DocumentEntity[];
  column: string;
}

const ArchiveItemsList: React.FC<ArchiveItemsListProps> = ({
  videoItems,
  documentItems,
  column,
}) => {
  if (videoItems.length === 0 && documentItems.length === 0) {
    return (
      <div className="col-12 text-center mt-5">
        <p>No results found based on the selected filters.</p>
      </div>
    );
  }

  return (
    <>
      {videoItems.length > 0 &&
        videoItems.map((item) => (
          <ArchiveElement
            key={`video-${item.id}`}
            column={column}
            item={item as unknown as DocumentEntity}
            type="video"
          />
        ))}
      {documentItems.length > 0 &&
        documentItems.map((item) => (
          <ArchiveElement
            key={`doc-${item.id}`}
            column={column}
            item={item}
            type="document"
          />
        ))}
    </>
  );
};

export default React.memo(ArchiveItemsList);
